module.exports = __webpack_public_path__ + "img/HR.c64c726e.svg";